module.exports = __webpack_public_path__ + "static/media/mn.fe5a69c8.svg";